import React from 'react';
import type { MouseEvent } from 'react';

import Button from '../../../components/buttons/Button';
import useScrollOnListItemFocus from '../../../components/lists/useScrollOnListItemFocus';

type FormulaDropdownListItemProps = {
    formulaQuery: string;
    focusedIndex: number;
    formula: string;
    index: number;
    onSelectFormula: (formula: string) => void;
};

const FormulaDropdownListItem: React.FC<FormulaDropdownListItemProps> = ({
    formulaQuery,
    focusedIndex,
    formula,
    index,
    onSelectFormula,
}) => {
    const [focused, listItemRef] = useScrollOnListItemFocus({ focusedIndex, index });

    const restOfFormula = formula.substring(formulaQuery.length);

    const onClick = (event: MouseEvent) => {
        onSelectFormula(formula);

        event.stopPropagation();
        event.preventDefault();
    };

    return (
        <li className={`formula-option ${focused}`} tabIndex={0} ref={listItemRef}>
            <Button onClick={onClick}>
                {!!formulaQuery && (
                    <>
                        <strong>{formulaQuery.toUpperCase()}</strong>
                        {restOfFormula}
                    </>
                )}
                {!formulaQuery && <>{formula}</>}
            </Button>
        </li>
    );
};

export default FormulaDropdownListItem;
